import script from "./InvoiceSingleView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSingleView.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__